import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { AppError } from '../../../../errors/AppError';
import api from '../../../../services/api';
import history from '../../../../services/history';

import { numberInputFormat } from '../../../../lib/inputUtils';

import TitleBar from '../../../../components/TitleBar';
import { FormWrapper, Form } from '../../../../components/Form';
import Input from '../../../../components/Form/Input';

const schema = Yup.object().shape({
  idItem: Yup.string().required('O campo "Item" deve ser preenchido'),
  partnumber: Yup.string().required('O campo "Partnumber" deve ser preenchido'),
  quantidade: Yup.number()
    .typeError('O campo "Quantidade" deve ser preenchido')
    .required('O campo "Quantidade" deve ser preenchido'),
  nota: Yup.string().nullable(),
  especTecnica: Yup.string().nullable(),
  ordena: Yup.number()
    .typeError('O campo "Ordena" deve ser preenchido')
    .required('O campo "Ordena" deve ser preenchido'),
});

function CatalogoItemEditar() {
  const location = useLocation();
  const { idCatalogo, idPagina, idItem, idMaterial } = location.state;

  const formRef = useRef(null);

  const IDIOMA = {
    PT_BR: 0,
    EN: 1,
  };

  const [itemCatalogo, setItemCatalogo] = useState(null);
  const [idioma, setIdioma] = useState(null);

  useEffect(() => {
    api.get(`/catalogo/${idCatalogo}`).then((response) => {
      setIdioma(response.data.idioma);
    });
  }, [idCatalogo]);

  useEffect(() => {
    api
      .get(
        `/catalogo/${idCatalogo}/pagina/${idPagina}/item/${idItem}/${idMaterial}`
      )
      .then((response) => {
        const { quantidade, materialFabricante, ...item } = response.data;
        setItemCatalogo({
          ...item,
          ...materialFabricante,
          quantidade: response.data.quantidade.toFixed(4),
        });
      });
  }, [idCatalogo, idPagina, idItem, idMaterial]);

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          abortEarly: false,
        });

        const {
          quantidade,
          nota,
          especTecnica,
          ordena,
          idPaginaOrigem,
          partnumber,
          descricaoBR,
          descricaoEN,
        } = data;

        const descricao =
          Number(idioma) === IDIOMA.PT_BR ? descricaoBR : descricaoEN;

        await api.put(
          `/catalogo/${idCatalogo}/pagina/${idPagina}/item/${idItem}/${idMaterial}`,
          {
            partnumber,
            descricao,
            quantidade,
            nota,
            especTecnica,
            ordena,
            idPaginaOrigem,
          }
        );

        toast.success('Item alterado com sucesso!');

        history.goBack();
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [IDIOMA, idioma, idCatalogo, idPagina, idItem, idMaterial]
  );

  return (
    <>
      <TitleBar back={!!location.background} title="Editar item" />

      <FormWrapper>
        <Form
          ref={formRef}
          onSubmit={handleConfirmar}
          initialData={itemCatalogo}
          autoComplete="off"
        >
          <Form.Column>
            <Form.Row>
              <Input
                id="idItem"
                name="idItem"
                label="Item"
                width={400}
                disabled
              />
              <Input
                id="idMaterial"
                name="idMaterial"
                label="Material"
                disabled
              />
              <Input
                id="partnumber"
                name="partnumber"
                label="Partnumber"
                disabled
              />
            </Form.Row>
            <Form.Row>
              <Input
                id="descricaoBR"
                name="descricaoBR"
                label="Descrição (BR)"
                disabled={Number(idioma) !== IDIOMA.PT_BR}
              />
              <Input
                id="descricaoEN"
                name="descricaoEN"
                label="Descrição (EN)"
                disabled={Number(idioma) !== IDIOMA.EN}
              />
            </Form.Row>
            <Form.Row>
              <Input id="nota" name="nota" label="Nota" />
              <Input
                id="especTecnica"
                name="especTecnica"
                label="Espec. Técnica"
              />
            </Form.Row>
            <Form.Row>
              <Input
                id="quantidade"
                name="quantidade"
                label="Quantidade"
                type="number"
                /** formata valor decimal */
                pattern="[0-9]+([\.,][0-9]+)?"
                step="0.0001"
                min="0.0000"
                onBlur={(e) => numberInputFormat(e, formRef, 4)}
              />
              <Input id="ordena" name="ordena" label="Ordena" type="number" />
              <Input
                id="idPaginaOrigem"
                name="idPaginaOrigem"
                label="Página Origem"
                type="number"
              />
            </Form.Row>
          </Form.Column>
          <Form.Separate withFlex />
          <Form.Footer>
            <button
              id="btn-cancel"
              type="button"
              onClick={() => history.goBack()}
            >
              Cancelar
            </button>
            <button id="btn-submit" type="submit">
              Salvar
            </button>
          </Form.Footer>
        </Form>
      </FormWrapper>
    </>
  );
}

export default CatalogoItemEditar;
